const REG_PLAIN = /^[\u4e00-\u9fa5_\-./a-zA-Z0-9]+$/ // 通用字符判断  支持中文、大小写字母、数字、短划线、下划线、斜杠和小数点

const OTA_VERSION = /^[_\-.a-zA-Z0-9]+$/ // 大小写字母、数字、点号（.）、中划线（-）和下划线（_）
const REG_NUMBER = /^(0|[1-9]\d*)$/ // 正整数和0
const REG_EMAIL // 邮箱
  = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/

// 支持字母、数字、-、_，包含字母且不以特殊符号开头(4-20位)
const REG_ACCOUNT = /(?=.*[A-Za-z])^[A-Za-z0-9][a-zA-Z0-9_-]{3,19}$/
const REGEX_LUA = /(\.Lua|\.lua|\.zip)$/
const REGEX_SHELL = /(\.sh|\.zip)$/
const REGEX_PYTHON = /(\.py|\.pyc|\.pyo|\.pyi|\.pyw|\.pyd|\.pyx|\.zip)$/

function isNumber(str: string) { // 正整数和0
  return REG_NUMBER.test(str)
}
function isFloat(str: string, percision = 0, miuns = false) {
  if (!percision) return isNumber(str)
  const miunsStr = miuns ? '-?' : ''
  const reg = new RegExp(`^${miunsStr}(([1-9]{1}\\d*)|0)(\\.\\d{1,${percision}})?$`)
  return reg.test(str)
}

export { REG_PLAIN, OTA_VERSION, isFloat, isNumber, REG_EMAIL, REG_ACCOUNT, REGEX_LUA, REGEX_SHELL, REGEX_PYTHON }
